// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { DatePickerEnd } from "../../components/select-date-end";
import { DatePickerStart } from "../../components/select-date-start";
import { SelectBranch } from "../../components/select-react-branches";
import { SelectCenterCost } from "../../components/select-react-center-cost";
import axios from "axios";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Icons } from "../../components/spinner";
import useStoreTimToa from "../../store/useStoreTimToa";
import { CurrentEmployeesWorking } from "../../components/charts/tim-toa/CurrentEmployeesWorking";
import { formatDateFromSelect } from "../../utils/formatDateFromSelect";
import { formatDataChartCurrentEmployeesWorking } from "../../utils/formatDataChartCurrentEmployeesWorking";
import { formattUrlParams } from "../../utils/formattUrlParams";
import { ClockRegisterEmployees } from "../../components/charts/tim-toa/ClockRegisterEmployees";
import { formatDataChartClockRegisterEmployee } from "../../utils/formatDataChartClockRegisterEmployee";
import { WorkOccupation } from "../../components/charts/tim-toa/WorkOccupation";
import { OccupationBySupervisor } from "../../components/charts/tim-toa/OccupationBySupervisor";
import { EmployeeStatus } from "../../components/charts/tim-toa/EmployeeStatus";
import { PriorityByTime } from "../../components/charts/tim-toa/PriorityByTime";
import { OpenCloseTSK } from "../../components/charts/tim-toa/openCloseTSK";

export default function Indicators() {
  const [options, setOptions] = useState({});
  const {
    centerCost,
    branch,
    startDate,
    endDate,
    setTotalEmployees,
    setLoadingChartCurrentEmployeesWorking,
    setCurrentEmployeesWorkingData,
    setLoadingChartClockRegisterEmployees,
    setClockRegisterEmployeesData,
    setLoadingChartWorkOccupation,
    setWorkOccupationData,
    setLoadingChartEmployeeStatus,
    setEmployeeStatusData,
    setLoadingChartPriorityByTime,
    setPriorityByTimeData,
    setOpenCloseTSKData,
    setLoadingChartOpenCloseTSK,
  } = useStoreTimToa((state) => state);

  async function getCurrentEmployeesWorking() {
    setLoadingChartCurrentEmployeesWorking(true);
    setTotalEmployees(0);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/funcionarios/tim/disponibilidade",
    });

    try {
      const { data } = await axios.get(url);
      const formattedData = formatDataChartCurrentEmployeesWorking(data);
      setCurrentEmployeesWorkingData(formattedData);
      setTotalEmployees(data.total_tecnicos_disponiveis);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartCurrentEmployeesWorking(false);
  }

  async function getClockRegisterEmployees() {
    setLoadingChartClockRegisterEmployees(true);
    setClockRegisterEmployeesData([]);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/funcionarios/tim/batidas",
    });
    try {
      const { data } = await axios.get(url);
      const formattedData = formatDataChartClockRegisterEmployee(data);
      setClockRegisterEmployeesData(formattedData);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartRegisterEmployees(false);
  }

  async function getWorkOccupation() {
    setLoadingChartWorkOccupation(true);
    setWorkOccupationData(null);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/funcionarios/tim/ocupacao",
    });
    try {
      const { data } = await axios.get(url);
      setWorkOccupationData(data);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartWorkOccupation(false);
  }

  async function getEmployeeStatus() {
    setLoadingChartEmployeeStatus(true);
    setEmployeeStatusData(null);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/funcionarios/tim",
    });
    try {
      const { data } = await axios.get(url);
      setEmployeeStatusData(data);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartEmployeeStatus(false);
  }

  async function getPriorityByTime() {
    setLoadingChartPriorityByTime(true);
    setPriorityByTimeData(null);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/toa/tsk/prioridade",
    });
    try {
      const { data } = await axios.get(url);
      setPriorityByTimeData(data);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartPriorityByTime(false);
  }

  async function getOpenCloseTSK() {
    setLoadingChartOpenCloseTSK(true);
    setOpenCloseTSKData(null);
    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      baseUrl: "https://radar.tlpservicos.com.br/api/toa/tsk/open-close",
    });
    try {
      const { data } = await axios.get(url); //
      setOpenCloseTSKData(data);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartOpenCloseTSK(false);
  }

  function handleGenerateCharts() {
    getCurrentEmployeesWorking();
    getClockRegisterEmployees();
    getWorkOccupation();
    getEmployeeStatus();
    getPriorityByTime();
    getOpenCloseTSK();
  }

  return (
    <>
      <div className="flex gap-2 mb-4">
        <SelectCenterCost />
        <SelectBranch />
        <DatePickerStart />
        <DatePickerEnd />
        <Button onClick={handleGenerateCharts}>Gerar Gráficos</Button>
      </div>
      <div className="grid grid-cols-2 gap-8 px-8">
        <CurrentEmployeesWorking />
        <ClockRegisterEmployees />
        <EmployeeStatus />
        <WorkOccupation />
        <OccupationBySupervisor />
        <PriorityByTime />
        <OpenCloseTSK />
      </div>
    </>
  );
}
